import { render } from "./program_consent_checkbox.vue?vue&type=template&id=799449ed"
import script from "./program_consent_checkbox.vue?vue&type=script&lang=js"
export * from "./program_consent_checkbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__